import React, { useEffect } from "react";
// 导入 AOS 动画库及其样式
import Aos from "aos";
import "aos/dist/aos.css";
// 导入自定义 CSS 样式
import "./footer.css";
// 导入背景视频资源
import video2 from "../../Assets/home-footer-video.mp4";

// 导入所需图标
import { FiChevronRight, FiSend } from "react-icons/fi";
import { MdOutlineTravelExplore } from "react-icons/md";
import {
  AiOutlineYoutube,
  AiOutlineWechat,
  AiOutlineFacebook,
  AiOutlineWhatsApp,
} from "react-icons/ai";

/*
  LinkGroup 组件：
  - 用于显示一组带图标的链接，减少重复代码。
  - 接收三个 props:
      title: 链接组标题；
      links: 链接文本数组；
      duration: AOS 动画持续时间（毫秒）。
*/
const LinkGroup = ({ title, links, duration }) => (
  <div data-aos="fade-up" data-aos-duration={duration} className="linkGroup">
    <span className="groupTitle">{title}</span>
    {links.map((link, index) => (
      // 每个链接项添加唯一的 key，使用图标和链接文本构成列表项
      <li key={index} className="footerList flex">
        <FiChevronRight className="icon" /> {link}
      </li>
    ))}
  </div>
);

/*
  Footer 组件：
  - 用于展示网站页脚，包括背景视频、联系信息、社交媒体图标和服务链接。
  - 利用 AOS 动画库为各部分添加淡入效果。
*/
const Footer = () => {
  // 在组件挂载时初始化 AOS 动画，设置动画持续时间为 2000 毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="footer">
      {/* 背景视频区域 */}
      <div className="videoDiv">
        <video src={video2} loop autoPlay muted type="video/mp4" />
      </div>

      {/* 页脚主要内容区域 */}
      <div className="secContent container">
        {/* 联系信息区域 */}
        <div className="contactDiv flex">
          {/* 显示一段提示文本，使用 AOS 动画效果 */}
          <div data-aos="fade-up" className="text">
            <h4>优惠码将为您返还现金</h4>
          </div>

          {/* 输入区域：用于输入优惠码和信箱，并发送数据 */}
          <div className="inputDiv flex">
            {/* 输入优惠码 */}
            <input
              data-aos="fade-up"
              type="text"
              placeholder="输入优惠码"
            />
            {/* 输入信箱 */}
            <input
              data-aos="fade-up"
              type="text"
              placeholder="输入您的信箱"
            />
            {/* 发送按钮 */}
            <button
              data-aos="fade-up"
              className="btn flex"
              type="submit"
            >
              发送 <FiSend className="icon" />
            </button>
          </div>
        </div>

        {/* 页脚卡片区域 */}
        <div className="footerCard flex">
          {/* 页脚介绍区域 */}
          <div className="footerIntro flex">
            {/* Logo 部分 */}
            <div className="logoDiv">
              <a href="#" className="logo flex">
                <MdOutlineTravelExplore className="icon" /> 交 流 改 变 未 来 .
              </a>
            </div>

            {/* 页脚说明文本 */}
            <div data-aos="fade-up" className="footerParagraph">
              交流教育致力于将最前沿、最传统、最优质、最典型的教育资源，整合在旅途中。身临其境，与现场的教育工作者、当地的同龄人一起，
              体验不同的教育理念、方法和成果。<br /><br />
              短暂的行程，可能会对你的人生产生，巨大的影响。<br /><br />
              来体验。
            </div>

            {/* 社交媒体图标区域 */}
            <div data-aos="fade-up" className="footerSocials flex">
              <AiOutlineYoutube className="icon" />
              <AiOutlineWechat className="icon" />
              <AiOutlineFacebook className="icon" />
              <AiOutlineWhatsApp className="icon" />
            </div>
          </div>

          {/* 页脚链接区域，使用 Grid 布局展示多个 LinkGroup 组件 */}
          <div className="footerLinks grid">
            <LinkGroup
              title="我 们 的 服 务"
              links={["服 务", "保 险", "代 理", "旅 程", "付 款"]}
              duration="3000"
            />
            <LinkGroup
              title="我 们 的 伙 伴"
              links={["预定", "租赁", "住宿", "查询", "机票"]}
              duration="4000"
            />
            <LinkGroup
              title="抢 先 体 验"
              links={["美国", "加拿大", "德国", "英国", "南欧"]}
              duration="5000"
            />
          </div>

          {/* 页脚底部信息 */}
          <div className="footerDiv flex">
            <small>最 好 的 教 育 交 流 之 旅</small>
            <small>COPYRIGHTS RESERVED - E4E 2024</small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;